import { IconShield, IconReceipt, IconBolt, IconClock, IconCalendar, IconPercent } from './icons';

/* ── Todo incluido ────────────────────────────────────────────────────── */
const INCLUIDO = [
  { Icon: IconShield, h: 'Seguro multianual', p: 'Cobertura amplia durante todo el plazo del arrendamiento, fraccionada en tu renta.' },
  { Icon: IconReceipt, h: 'Tenencias y placas', p: 'Los trámites y pagos anuales del auto, incluidos. Sin filas, sin sorpresas.' },
  { Icon: IconBolt, h: 'Una sola renta mensual', p: 'Todo en un pago claro y predecible al mes. No hay letras chiquitas.' },
  { Icon: IconClock, h: 'Respuesta en 24 h', p: 'Análisis ágil para que estrenes pronto, sin trámites eternos.' },
  { Icon: IconCalendar, h: 'Plazos a tu medida', p: 'De 12 a 60 meses. Tú eliges el plazo que mejor se acomoda a ti.' },
  { Icon: IconPercent, h: 'Beneficio fiscal', p: 'Maximiza las ventajas fiscales de tu auto con el plan adecuado.' },
];

const Incluido = () => (
  <section className="sec" id="incluido">
    <div className="wrap reveal">
      <div className="incluido"><div className="inner2">
        <div className="ihead">
          <div className="sec-eyebrow">Solo con Peicar</div>
          <h2 className="sec-title">Todo incluido en <b>una sola renta.</b></h2>
          <p className="lead">Olvídate de gastos sueltos. Tu seguro, tenencias y placas viajan dentro de tu renta mensual. Así de claro y transparente.</p>
        </div>
        <div className="grid3">{INCLUIDO.map(({ Icon, h, p }) => (<div className="inc-card" key={h}><div className="ic"><Icon /></div><div className="h">{h}</div><div className="p">{p}</div></div>))}</div>
      </div></div>
    </div>
  </section>
);

export default Incluido;
